import { render, staticRenderFns } from "./DesignSamplesDialog.vue?vue&type=template&id=20df9946"
import script from "./DesignSamplesDialog.vue?vue&type=script&lang=ts"
export * from "./DesignSamplesDialog.vue?vue&type=script&lang=ts"
import style0 from "./DesignSamplesDialog.vue?vue&type=style&index=0&id=20df9946&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports